import React from "react";

export const WarningDiamond = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.7081 7.29503L8.70494 1.29128C8.51758 1.10503 8.26413 1.00049 7.99994 1.00049C7.73576 1.00049 7.48231 1.10503 7.29494 1.29128L1.29494 7.29503C1.10869 7.48239 1.00415 7.73585 1.00415 8.00003C1.00415 8.26422 1.10869 8.51767 1.29494 8.70503L7.29807 14.7088C7.48543 14.895 7.73888 14.9996 8.00307 14.9996C8.26725 14.9996 8.52071 14.895 8.70807 14.7088L14.7112 8.70503C14.8974 8.51767 15.002 8.26422 15.002 8.00003C15.002 7.73585 14.8974 7.48239 14.7112 7.29503H14.7081ZM7.49994 5.00003C7.49994 4.86742 7.55262 4.74025 7.64639 4.64648C7.74016 4.55271 7.86733 4.50003 7.99994 4.50003C8.13255 4.50003 8.25973 4.55271 8.3535 4.64648C8.44727 4.74025 8.49994 4.86742 8.49994 5.00003V8.50003C8.49994 8.63264 8.44727 8.75982 8.3535 8.85358C8.25973 8.94735 8.13255 9.00003 7.99994 9.00003C7.86733 9.00003 7.74016 8.94735 7.64639 8.85358C7.55262 8.75982 7.49994 8.63264 7.49994 8.50003V5.00003ZM7.99994 11.5C7.85161 11.5 7.7066 11.456 7.58327 11.3736C7.45993 11.2912 7.3638 11.1741 7.30703 11.037C7.25027 10.9 7.23542 10.7492 7.26435 10.6037C7.29329 10.4582 7.36472 10.3246 7.46961 10.2197C7.5745 10.1148 7.70814 10.0434 7.85363 10.0144C7.99911 9.9855 8.14991 10.0004 8.28696 10.0571C8.424 10.1139 8.54113 10.21 8.62355 10.3334C8.70596 10.4567 8.74994 10.6017 8.74994 10.75C8.74994 10.9489 8.67093 11.1397 8.53027 11.2804C8.38962 11.421 8.19886 11.5 7.99994 11.5Z"
        fill="#C58300"
      />
    </svg>
  );
};

export default WarningDiamond;
